import { styled } from '@mui/material';
import { BaseCard } from 'console/shared/styles/mixins/base-card';
import { ControlButton } from '../../../buttons/control';
export const GuardControlCard = styled(BaseCard)({
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    justifyContent: 'space-between',
});
export const GuardControlButton = styled(ControlButton)({});
